export function trackPageView(url) {
	if(process.env.NODE_ENV === 'production') {
		if(window.hj) {
			window.hj('vpv', url); // turn /url into url for hotjar.
		}
		if(window.ga) {
			const ga = window.ga;
			ga('set', 'page', url);
			ga('send', 'pageview');
		}
	} else {
		console.log(`Tracked pageview: ${url}`);
	}
};

export function trackEvent(action, label) {
	const eventCategory = 'Control Interaction';
	if(process.env.NODE_ENV === 'production') {
		if(window.ga) {
			const ga = window.ga;
			ga('send', 'event', eventCategory, action, label);
		}
	} else {
		console.log(`Tracked event: ${eventCategory}, ${action}, ${label}`);
	}
}

export default {
	trackEvent, trackPageView
};


// WEBPACK FOOTER //
// ./src/utils/stats_tracker.js